import { Switch as ChakraSwitch } from '@chakra-ui/switch';
import { Label, Tooltip } from 'components';
import React, { ComponentProps, memo } from 'react';

import * as Styles from './styles';

interface IProps extends ComponentProps<typeof ChakraSwitch> {
  label?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  tooltip?: string;
}

const SwitchComponent: React.FC<IProps> = ({ label, inputRef, tooltip, ...props }) => {
  return (
    <Styles.Container>
      <ChakraSwitch colorScheme="teal" ref={inputRef} isDisabled={props.disabled} {...props} />

      {label && (
        <Label htmlFor={label}>
          {label}
          {tooltip && <Tooltip tip={tooltip} iconName="exclamation" />}
        </Label>
      )}
    </Styles.Container>
  );
};

export const SwitchField = memo(SwitchComponent);
